import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import * as countries from 'i18n-iso-countries' ;
import router, { bootstrapAsync } from './router';
import store from './store';
import i18n from './locales';
import { _registerServiceWorker } from './utils/ServiceWorker.util' ;

bootstrapAsync(store);

import Axios, { CancelTokenStatic, CancelTokenSource } from 'axios';
import { AxiosHelper } from './utils/AxiosHelper.util';
import App from './containers/app/App.vue';
//@ts-ignore
import * as VueGoogleMaps from 'vue2-google-maps';
/** Third-party registration */
// const Vuetify = require('vuetify');
import * as Vuetify from 'vuetify';
import * as VueCookie from 'vue-cookie';
import VueImg from 'v-img';
import theme from './themes/color';
import VueTelInput from 'vue-tel-input'
import VueGoogleCharts from "vue-google-charts";
import VueSignaturePad from 'vue-signature-pad';



Vue.use(Vuetify as any, { theme });
Vue.use(VueCookie);
Vue.use(VueGoogleCharts)
Vue.use(VueImg, {
  // Use `alt` attribute as gallery slide title
  altAsTitle: false,
  // Display 'download' button near 'close' that opens source image in new tab
  sourceButton: false,
  // Event listener to open gallery will be applied to <img> element
  openOn: 'click',
  // Show thumbnails for all groups with more than 1 image
  thumbnails: false,
});
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyCfQLVl__3oEe2Xg3rCzmkAbliic7Lv7Q0',
    libraries: 'places', // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)

    //// If you want to set the version, you can do so:
    // v: '3.26',
  },

  //// If you intend to programmatically custom event listener code
  //// (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
  //// instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
  //// you might need to turn this on.
  // autobindAllEvents: false,

  //// If you want to manually install components, e.g.
  //// import {GmapMarker} from 'vue2-google-maps/src/components/marker'
  //// Vue.component('GmapMarker', GmapMarker)
  //// then disable the following:
  // installComponents: true,
})
Vue.use(VueTelInput)
Vue.use(VueSignaturePad)


/** End of Third-party registration */
import './assets/main.scss';
import 'material-design-icons-iconfont/dist/material-design-icons.css';
import 'babel-polyfill';
import 'vuetify/dist/vuetify.min.css';
import 'vue-tel-input/dist/vue-tel-input.css';
import 'vue-swatches/dist/vue-swatches.css'
import { namespace } from 'vuex-class';
import {
  AUTHORIZATION_MODULE_NAMESPACE,
  AUTHORIZATION_CHECK_SESSION
} from './store/authorization';
import { USER_MODULE_NAMESPACE } from './store/user/user-types.store';
import VueRouter from 'vue-router';

Vue.config.errorHandler = (err, vm, info) => {
  console.info('Infomartion', info)
  console.info('=====================================')
  console.info('Component:', vm);
  console.error('Exception:', err);
  console.info('=====================================')
}

if(process.env.NODE_ENV !== 'development' ){
  Vue.config.devtools= false
  Vue.config.productionTip= false
  console.log= function(){}
}

const AuthorizationStore = namespace(AUTHORIZATION_MODULE_NAMESPACE);
const UserStore = namespace(USER_MODULE_NAMESPACE);

@Component({
  template: '<App :disconnected.sync="dtIsDisconnected" :visible="visible" />',
  components: { App }
})
class RootApp extends Vue {

  dtIsDisconnected: boolean;
  dtCancelToken: CancelTokenStatic;
  dtCancelTokenSource: CancelTokenSource;





  @AuthorizationStore.Action(AUTHORIZATION_CHECK_SESSION)
  storeCheckSession: (router: VueRouter) => void;



  @UserStore.Getter modules: { [props: string]: any };
  @UserStore.Getter userInfo: { id: number }

  constructor(props: any) {
    super(props);
    this.dtCancelToken = Axios.CancelToken;
    this.dtCancelTokenSource = this.dtCancelToken.source();
    this.dtIsDisconnected = false;
    Axios.defaults.validateStatus = (status) => AxiosHelper.statusValidator(status);
    Axios.interceptors.request.use(
      (config) => AxiosHelper.interceptorRequest(config),
      (error) => AxiosHelper.handleException(error,
        (event) => this.handleDisconnected(event))
    )

    Axios.interceptors.response.use(
      (response) => AxiosHelper.interceptorResponse(response, this),
      (error) => AxiosHelper.handleException(error,
        (event) => this.handleDisconnected(event))
    )

    this.registerSW()
    this.configCountriesI18n()
  }

  created() {
    const { pathname } = location
    const isExceptionPath: boolean = pathname !== '/sign-up'
      && pathname !== '/reset'
      && pathname !== '/verify'
      && pathname !== '/forgot-password'
    if (isExceptionPath) {
      this.storeCheckSession(this.$router);
    }
  }

  mounted(){
    if(process.env.NODE_ENV === 'production'){
      if(!document.getElementById('uxTag')){
        const script = document.createElement('script');
        script.id = 'uxTag';
        script.async = true;
        script.src = 'https://opentech-ux.org/lom-captor/dist/opentech-ux-lib.js';
        script.setAttribute('data-endpoint', 'https://drive-im.ux-key.com/endpoint')
        document.head.appendChild(script);
      } 
    }
  }

  get visible(): boolean {
    return this.userInfo.id > 0;
  }

  _clearTimeout: any;
  handleRedirectToHome() {
    clearTimeout(this._clearTimeout)
    this._clearTimeout = setTimeout(() => {
      if (location.pathname === '/'
        || location.pathname === '/sign-up'
        || location.pathname === '/reset'
        || location.pathname === '/verify'
        || location.pathname === '/forgot-password'
      ) return;
      location.href = '/'
    }, 300);
  }
  handleDisconnected(event) {

    if (this.$route.name !== "ticket_chat") {
      this.dtIsDisconnected = true;
      this.dtCancelTokenSource.cancel('Disconnected from the server');
    }

  }

  configCountriesI18n(){
    countries.registerLocale(require('i18n-iso-countries/langs/fr.json'))
    countries.registerLocale(require('i18n-iso-countries/langs/en.json'))
  }

  registerSW(){
    _registerServiceWorker(process.env.NODE_ENV,worker => {
        if(worker){
          this.$store.commit('UPDATE_SNACKBAR_STATUS',true)
          this.$store.commit('UPDATE_WORKER',worker)
        }
    })
  }
}

/** Global components registration */
Vue.component('base-container', async () => import('./containers/BaseContainer.vue'));
Vue.component('base-modal', async () => import('./components/modal/Modal.vue'));
Vue.component('base-modal-duplicate', async () => import('./components/modal-duplicate/Modal.vue'))
Vue.component('base-modal-submit-btn', async () => import('./components/modal-record-button/ModalRecordButton.vue'));
Vue.component('base-datetime-picker', async () => import('./components/datetime-picker/DatetimePicker.vue'));
Vue.component('base-datetime-picker-range', async () => import('./components/datetime-picker-range/DatetimePickerRange.vue'));
Vue.component('base-datetime-picker-range-vertical', async () => import('./components/datetime-picker-range-vertical/DatetimePickerRangeVertical.vue'));
Vue.component('base-datetime-picker-solo-vertical', async () => import('./components/datetime-picker-solo-vertical/DatetimePickerSoloVertical.vue'));
Vue.component('base-block-select', async () => import('./components/block-select/BlockSelect.vue'));
Vue.component('base-multi-select', async () => import('./components/multi-select/MultiSelect.vue'));
Vue.component('base-search-selector', async () => import('./components/search-selector/SearchSelector.vue'));
Vue.component('base-control-label', async () => import('./components/control-label/ControlLabel.vue'));
Vue.component('base-control-label-vertical', async () => import('./components/control-label-vertical/ControlLabelVertical.vue'));
Vue.component('base-notification', async () => import('./components/modal-notification/ModalNotification.vue'));
Vue.component('base-infinity-loading', async () => import('./components/infinity-loading/InfinityLoading.vue'));
Vue.component('base-condition-selector', async () => import('./components/condition-selector/ConditionSelector.vue'));
Vue.component('base-autocomplete', async () => import('./components/autocomplete/Autocomplete.vue'));
Vue.component('base-date-picker-range', async () => import('./components/date-picker-range/DatePickerRange.vue'));
Vue.component('base-order-by', async () => import('./components/orderby/OrderBy.vue'));
Vue.component('base-entities-search', async () => import('./components/entities-search-selector/EntitiesSearchSelector.vue'));
Vue.component('base-paginator', async () => import('./components/paginator/Paginator.vue'))
Vue.component('base-attachment-button', async () => import('./components/attachment-button/AttachmentButton.vue'))
Vue.component('base-attachment-drag-drop', async () => import('./components/attachment-drag-drop/AttachmentDragDrop.vue'))
Vue.component('base-error-dialog', async () => import('./components/error-dialog/ErrorDialog.vue'))
Vue.component('base-delete-dialog', async () => import('./components/delete-dialog/DeleteDialog.vue'))
Vue.component('base-address-fields', async () => import('./components/address-fields/AddressFields.vue'))
Vue.component('base-attribute-manager', async () => import('./components/attribute-manager/AttributeManager.vue'))
Vue.component('base-attribute-value', async () => import('./components/attribute-label-value/AttributeLabelValue.vue'))
/** End of global components registration */

export const eventBus = new Vue()

new RootApp({ el: '#app', router, store, i18n }).$mount();



// WEBPACK FOOTER //
// ./src/main.ts